import { render, staticRenderFns } from "./DetailedTraceability.vue?vue&type=template&id=fb0a15fc&"
import script from "./DetailedTraceability.vue?vue&type=script&lang=js&"
export * from "./DetailedTraceability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports